var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M18.842 2.944a2.36 2.36 0 0 0-1.664-1.668C15.71.882 9.824.882 9.824.882s-5.887 0-7.355.394A2.36 2.36 0 0 0 .805 2.944c-.393 1.47-.393 4.54-.393 4.54s0 3.069.393 4.54a2.33 2.33 0 0 0 1.664 1.64c1.468.395 7.355.395 7.355.395s5.886 0 7.354-.394a2.33 2.33 0 0 0 1.664-1.641c.393-1.471.393-4.54.393-4.54s0-3.07-.393-4.54M7.898 10.27V4.698l4.92 2.786z"
  })));
};
export default SvgYoutube;